<template>
  <div>
    <p>Posts</p>
    <div>
      <div v-for="post in posts" :key='post.dateAdded'>
        {{$time(post.dateAdded).calendar()}}
        <br>
        {{post.title}}
        <br>
        {{post.post}}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'posts',
  data () {
    return {
      posts: ''
    }
  },
  created () {
    this.$http.get('/posts').then(response => {
      this.posts = response.data
      console.log(this.posts)
    }).catch(() => {
      console.log('failed to load posts')
      this.posts = [{title: 'failed to load posts'}]
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Posts.vue